'use strict';

function _AnalyticsData() {
  this.analyticsData = {
    productNames: {
      card: 'Spending',
      crypto: 'Crypto',
      loan: 'Money',
      protect: 'Protect',
      creditscore: 'Credit Score',
      mortgage: 'Mortgage'
    },
    'virtual-page-view': {
      event: 'DLevent.Pageview',
      Page: function Page(pageName) {
        if (pageName) {
          return pageName;
        }
        return window.location.href;
      }
    },
    'generic-push-event': {
      event: function event(DLevent) {
        return 'DLevent.' + DLevent;
      }
    },
    'connection-issue': {
      event: 'DLevent.ServerIssue',
      Issue: function Issue(issue) {
        return issue;
      },
      ProductAffected: function ProductAffected(productLabel) {
        return productLabel;
      }
    },
    'connection-issue-try-again': {
      event: 'DLevent.ServerIssue',
      Issue: function Issue(issue) {
        return issue;
      },
      ProductAffected: function ProductAffected(productLabel) {
        return productLabel;
      }
    },
    referral: {
      ReferralCode: function ReferralCode(codeStatus) {
        return codeStatus;
      },

      event: 'DLevent.referral'
    },
    'form-submit': {
      event: 'DLevent.FormSubmit',
      FormID: function FormID(formAnalyticsID) {
        return formAnalyticsID;
      }
    },
    'form-errors': {
      FormErrors: function FormErrors(fieldsWithError) {
        return fieldsWithError;
      },

      event: 'DLevent.FormErrors'
    },
    'login-dialog': {
      event: 'DLevent.Pageview',
      Page: '/login-dialog'
    },
    'expired-session': {
      event: 'DLevent.Logout',
      Logout: 'Time out'
    },
    'logged-out': {
      event: 'DLevent.Logout',
      Logout: 'Success'
    },
    'mortgage-rates-view': {
      event: 'DLevent.mortgageProducts',
      featuredName: function featuredName(productName) {
        return productName;
      },
      featuredRate: function featuredRate(_featuredRate) {
        return _featuredRate;
      },
      selectedProduct: function selectedProduct(_selectedProduct) {
        return _selectedProduct;
      },
      selectedRate: function selectedRate(_selectedRate) {
        return _selectedRate;
      },
      competingNames: function competingNames(competingBanks) {
        return competingBanks;
      },
      competingRates: function competingRates(_competingRates) {
        return _competingRates;
      }
    },
    'help-desk': {
      event: 'DLevent.helpDeskQuestions',
      helpDeskQuestions: function helpDeskQuestions(questions) {
        if (questions) {
          return questions;
        }
        return 'Common Questions';
      },
      helpDeskIDs: function helpDeskIDs(ids) {
        return ids;
      }
    },
    'generic-member-navigation': {
      memberNavigation: function memberNavigation(action) {
        return action;
      },

      event: 'DLevent.memberNavigation'
    },
    'testimonial-slide-view': {
      event: 'DLevent.testimonialShown',
      testimonialName: function testimonialName(value) {
        return value;
      },
      testimonialSource: function testimonialSource(value) {
        return value.toLowerCase();
      },
      testimonialQuote: function testimonialQuote(value) {
        return value.substr(0, 10);
      }
    }
  };

  this.init = function () {};
  this.initAllReady = function () {};
}